import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { SortIcon } from '@/icons/sort-icon';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/recommendation-management/main-page')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="recommendationManagement.mainPage.crumb" icon={SortIcon} />,
      title: <Translation id="recommendationManagement.mainPage.crumb" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
